import {
  Alert,
  AlertFromJSON,
  defaultProcessInspectionCollection,
  exists,
  ProcessInspectionCollection,
  ProcessInspectionCollectionFromJSON
} from '@/api'

export interface ProcessInspection {
  collection: ProcessInspectionCollection
  messages: Alert[]
  receiptInfoReserve: any // 可変値のためanyとする
  receiptInfoReserveForwarding: any // 可変値のためanyとする
}

export function ProcessInspectionFromJSON(json: any): ProcessInspection {
  return {
    collection: exists(json, 'collection')
      ? ProcessInspectionCollectionFromJSON(json.collection)
      : defaultProcessInspectionCollection(),
    messages: exists(json, 'messages') ? json.messages.map(AlertFromJSON) : [],
    receiptInfoReserve: exists(json, 'receipt_info_reserve')
      ? json.receipt_info_reserve
      : undefined,
    receiptInfoReserveForwarding: exists(
      json,
      'receipt_info_reserve_forwarding'
    )
      ? json.receipt_info_reserve_forwarding
      : undefined
  }
}
